import { red } from "@ant-design/colors";
import { DeleteOutlined, DownloadOutlined } from "@ant-design/icons";
import { Spin } from "antd";
import React, { memo } from "react";
import { useIntl } from "react-intl";

import { TMessage } from "@/api";

import { IChatProps } from "./types";

interface IDeleteMessageProps
  extends Omit<IChatProps, "conversation" | "player"> {
  item: TMessage;
}

export const DeleteMessage = memo(({ state, item }: IDeleteMessageProps) => {
  const intl = useIntl();

  const handleDelete = () => {
    state.deleteMessage(item.messageId);
  };

  return (
    <>
      {state.deleteMessageQuery.isPending ? (
        <Spin size="small" />
      ) : (
        <DeleteOutlined
          onClick={handleDelete}
          style={{
            fontSize: "12px",
            marginLeft: "8px",
            color: red[4],
            cursor: "pointer",
          }}
          title={intl.formatMessage({ defaultMessage: "Delete message" })}
          aria-label={intl.formatMessage({
            defaultMessage: "Delete message",
          })}
        />
      )}
    </>
  );
});

DeleteMessage.displayName = "DeleteMessage";

interface IDownloadMediaProps {
  item: TMessage;
}

export const DownloadMedia = memo(({ item }: IDownloadMediaProps) => {
  const intl = useIntl();

  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = `/im/attachment/${item.text}`;
    link.download = item.text;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  if (item.type !== "image" && item.type !== "video") {
    return null;
  }

  return (
    <DownloadOutlined
      onClick={handleDownload}
      style={{
        fontSize: "12px",
        marginLeft: "8px",
        cursor: "pointer",
      }}
      title={intl.formatMessage({ defaultMessage: "Download" })}
      aria-label={intl.formatMessage({
        defaultMessage: "Download",
      })}
    />
  );
});

DownloadMedia.displayName = "DownloadMedia";
